"use client";

import { motion } from "framer-motion";
import Image from "next/image";

interface StoriesSectionProps {
  onDownloadClick?: () => void;
}

interface Comment {
  id: string;
  avatar: string;
  name: string;
  content: string;
  date: string;
  platformUrl: string;
}

const comments: Comment[] = [
  {
    id: "1",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Guri Saroy.png",
    name: "Guri Saroy",
    content:
      "Fellou didn't just beat the competition, it crushed them. Most accurate, clearest reports, deepest insights. Easiest to read And it's 3.1x faster than OpenAI.",
    date: "@HeyGurisaroy",
    platformUrl: "https://x.com/HeyGurisaroy/status/1921654501045567603",
  },
  {
    id: "2",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/AltcoinHassan.png",
    name: "AltcoinHassan",
    content:
      "That's a serious leap forward. We've gone from searching for info to delegating the entire process. AI that browses, filters, and delivers insights? That's not just a tool — it's a productivity multiplier. Fellou AI might just redefine how we interact with the internet.",
    date: "@AltcoinHassan",
    platformUrl: "https://x.com/AltcoinHassan/status/1921644787658280978",
  },
  {
    id: "3",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Guri Saroy.png",
    name: "Guri Saroy",
    content:
      "Spot EdTech Unicorns Before They Boom. Fellou researched 2025's top EdTech startups — including funding, key investors, and market positioning. It delivered a VC-style report with trends, insights, and early-stage opportunities — all in minutes.",
    date: "@HeyGurisaroy",
    platformUrl: "https://x.com/HeyGurisaroy/status/1921654410637398193",
  },
  {
    id: "4",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Guri Saroy.png",
    name: "Guri Saroy",
    content:
      "In-Depth Market & Product Research. Fellou researched the top 10 menstrual health apps, functions, pricing, reviews, funding, and more. As efficient as a top product intern, it delivered insights that would normally take a week to compile.",
    date: "@HeyGurisaroy",
    platformUrl: "https://x.com/HeyGurisaroy/status/1921654485145022852",
  },
  {
    id: "5",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Angry Tom.png",
    name: "Angry Tom",
    content:
      "Fellou is not just another browser, it's an Agentic assistant that takes action for you.",
    date: "@AngryTomtweets",
    platformUrl: "https://x.com/AngryTomtweets/status/1921585661259178207",
  },
  {
    id: "6",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/しまだ｜AIマーケ&クリエイ....png",
    name: "しまだ｜AIマーケ&ク...",
    content:
      "I tried using the popular browser Fellou. The report creation is more complete than Deep Research. It looks like there are preset internal report templates. The web crawl was extremely fast and the coding continued for over 10 minutes.",
    date: "@Shima_AIRDesign",
    platformUrl: "https://x.com/Shima_AIRDesign/status/1921480084533215622",
  },
  {
    id: "7",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Filipe _ IA.png",
    name: "Filipe | IA",
    content:
      "Chrome was for browsing. Fellou is for doing it. Manage the Internet so you can manage your life. The future is not the search, it is an exploration of action.",
    date: "@filicroval",
    platformUrl: "https://x.com/filicroval/status/1921500363581960361",
  },
  {
    id: "8",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/ADEMOLA.png",
    name: "ADEMOLA",
    content:
      "It's crazy how it can take care of tasks without me even clicking. Kudos to the Fellou AI team for this.",
    date: "@kii_tan___",
    platformUrl: "https://x.com/kii_tan___/status/1921475539052658743",
  },
  {
    id: "9",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Srini Annamaraju.png",
    name: "Srini Annamaraju",
    content:
      "Quietly one of the biggest shifts this year for tech enthusiasts. The agentic browser from Fellou could redefine how we interact with information online. In my experience, unique tools like this often lead to unexpected insights. Curious where this fits into the future of browsing.",
    date: "@SriniAnnamaraju",
    platformUrl: "https://x.com/SriniAnnamaraju/status/1921526536974311589",
  },
  {
    id: "10",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/MARLON.png",
    name: "MARLON",
    content: "This is the future of web browsing.",
    date: "@MarlonNFTs",
    platformUrl: "https://x.com/MarlonNFTs/status/1921487594640048580",
  },
  {
    id: "11",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/SwishBanksX.png",
    name: "SwishBanksX",
    content:
      "Everyone's hyped about AI doing the thinking but this is AI doing the doing. Agents that act on research > agents that just summarize it. Fellou isn't a browser. It's a silent operator. This is what real workflow automation looks like.",
    date: "@swishbanksX",
    platformUrl: "https://x.com/swishbanksX/status/1921381696802304076",
  },
  {
    id: "12",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Paul Burton.png",
    name: "Paul Burton",
    content:
      "After using Fellou for a couple of days I have got to say that this is the future of Browsers without any doubt it is an exceptional tool.",
    date: "@CyberDuck60",
    platformUrl: "https://x.com/CyberDuck60/status/1921458790831968639",
  },
  {
    id: "13",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Muhammad Ayan.png",
    name: "Muhammad Ayan",
    content: "Fellou out here making Chrome look ancient.",
    date: "@socialwithaayan",
    platformUrl: "https://x.com/socialwithaayan/status/1921445496884752455",
  },
  {
    id: "14",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Jorhmie_keys (TheLoveGuru).png",
    name: "Jorhmie_keys (The...",
    content:
      "Fellou AI really brought the future to us early. I am hyped for this. 🔥❤️",
    date: "@jorhmie_keys",
    platformUrl: "https://x.com/jorhmie_keys/status/1921479542125867471",
  },
  {
    id: "15",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Farhan.png",
    name: "Farhan",
    content:
      "Fellou feels less like a browser and more like a smartest team member.",
    date: "@mhdfaran",
    platformUrl: "https://x.com/mhdfaran/status/1921229264961126744",
  },
  {
    id: "16",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Brian Roemmele.png",
    name: "Brian Roemmele",
    content:
      "Fellou saves time and expands possibilities. Compared to traditional browsers, it cuts research time by hours — think 8 hours of work condensed into 6 hours of freedom. Its seamless integrations (e.g., Notion, LinkedIn) make workflows effortless.",
    date: "@BrianRoemmele",
    platformUrl: "https://x.com/BrianRoemmele/status/1921344961804747073",
  },
  {
    id: "17",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Douglas Bonneville.png",
    name: "Douglas Bonneville",
    content:
      "I got access a couple days ago. The reports are great for the test topics I tried. You can glimpse the agentic future.",
    date: "@dbonneville",
    platformUrl: "https://x.com/dbonneville/status/1921691708955283847",
  },
  {
    id: "18",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Russell Rosario.png",
    name: "Russell Rosario",
    content:
      "Fellou looks fascinating! I've been wondering how browser agents might reshape our online experience. The way it handles complex tasks automatically is quite impressive.",
    date: "@russellrosario",
    platformUrl: "https://x.com/russellrosario/status/1921237181051420782",
  },
  {
    id: "19",
    avatar: "https://cdn.fellou.ai/images/images/home/ugc/Poonam Soni.png",
    name: "Poonam Soni",
    content: "Fellou will change the way we use browser.",
    date: "@CodeByPoonam",
    platformUrl: "https://x.com/CodeByPoonam/status/1921458985690894831",
  },
];

export function StoriesSection({ onDownloadClick }: StoriesSectionProps) {
  return (
    <div className="relative py-20 px-6 lg:px-8">
      {/* Stories Section */}
      <div className="max-w-7xl mx-auto">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">Stories That Inspire</h2>
          <p className="text-xl text-white/80">Unleash productivity, redefine your browsing experience.</p>
        </motion.div>

        {/* Masonry Grid */}
        <div className="columns-1 md:columns-2 lg:columns-3 xl:columns-4 gap-6">
          {comments.map((comment, index) => (
            <motion.div
              key={comment.id}
              className="break-inside-avoid bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 mb-6 cursor-pointer hover:bg-white/10 transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              viewport={{ once: true }}
              onClick={() => window.open(comment.platformUrl, '_blank')}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <p className="text-white/90 mb-4 leading-relaxed text-sm lg:text-base">{comment.content}</p>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="relative w-8 h-8 rounded-full overflow-hidden bg-gray-600 flex-shrink-0">
                    <Image
                      src={comment.avatar}
                      alt={comment.name}
                      fill
                      className="object-cover"
                      sizes="32px"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-white font-medium text-sm truncate">{comment.name}</p>
                    <p className="text-white/60 text-xs">{comment.date}</p>
                  </div>
                </div>
                <div className="w-6 h-6 flex-shrink-0 ml-2">
                  <Image
                    src="https://cdn.fellou.ai/images/images/home/ugc/platform-x.svg"
                    alt="X Platform"
                    width={24}
                    height={24}
                    className="opacity-60"
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}